import type { ReactNode } from 'react';
import { cn } from './cn.js';

/// Liga e desliga, com o texto do que liga ao lado. É um botão com papel de chave, e não a caixa
/// de marcar do navegador: a nativa muda de desenho a cada plataforma e ignora o tema.
export function Switch({
  checked,
  onChange,
  disabled,
  children,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean | undefined;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className="flex cursor-pointer items-center gap-3 text-left text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50 disabled:cursor-not-allowed disabled:opacity-60"
    >
      <span
        aria-hidden="true"
        className={cn(
          'relative h-6 w-11 shrink-0 rounded-full transition',
          checked ? 'bg-brand-500' : 'bg-content/15',
        )}
      >
        <span
          className={cn(
            'absolute top-1 size-4 rounded-full bg-surface-card transition-transform duration-200 ease-out motion-reduce:transition-none',
            checked ? 'left-1 translate-x-5' : 'left-1 translate-x-0',
          )}
        />
      </span>
      {children}
    </button>
  );
}
